/* eslint-disable sort-keys */
import * as core from '../../../../../../../core'

import { query } from './billability-calculator.query'

export const RESOURCE = {
  payload: {
    alias: 'billability-calculator',
    content: {
      navigator: core.mosaic.Page.Segment.Navigator.Tabs,
      segments: [
        {
          name: 'Salary to Billability Rate',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'billability-calculator.salary-to-bill-rate',
                    },
                  },
                },
              },
            ],
          },
          alias: 'billability-calculator.salary-to-bill-rate',
          query: {},
        },
        {
          name: 'Billability Rate to Salary',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  widget: {
                    widget: {
                      alias: 'billability-calculator.bill-rate-to-salary',
                    },
                  },
                },
              },
            ],
          },
          alias: 'billability-calculator.bill-rate-to-salary',
          query: {},
        },
      ],
    },
    description: 'Billability Calculator',
    name: 'billability-calculator',
    query: {},
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
